/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomerCreditResponse,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerResponse,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaStatusRequest,
  FreightClassRequest,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteConfigUpdateRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTO,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
} from './type';
import request from '@/utils/request';

export class CustomerService {
  // 新增
  public static addCustomerUsingPOST(userRequest: OwnerUserRequest): Promise<R<string>> {
    return request('POST', '/customer/add', null, null, userRequest, null, null);
  }

  // 客户审批
  public static auditUsingPUT(auditRequest: OwnerUserAuditRequest): Promise<R<string>> {
    return request('PUT', '/customer/audit', null, null, auditRequest, null, null);
  }

  // 关闭信用额度
  public static creditClosedUsingPUT(cusId: number): Promise<R<string>> {
    return request('PUT', '/customer/credit-closed', null, { cusId }, null, null, null);
  }

  // 新增或更新信用额度
  public static creditEditUsingPOST(creditRequest: CreditEditRequest): Promise<R<string>> {
    return request('POST', '/customer/credit-edit', null, null, creditRequest, null, null);
  }

  // 信用额度详情
  public static creditInfoUsingGET(cusId: number): Promise<R<CustomerCreditResponse>> {
    return request('GET', '/customer/credit-info', null, { cusId }, null, null, null);
  }

  // 修改保存客户
  public static editCustomerUsingPOST(userRequest: OwnerUserEditRequest): Promise<R<string>> {
    return request('POST', '/customer/edit', null, null, userRequest, null, null);
  }

  // 订单导出
  public static exportCustomerUsingPOST(query: OwnerQueryRequest): Promise<void> {
    return request('POST', '/customer/export', null, null, query, null, null);
  }

  // 分页查询
  public static pageCustomerUsingPOST(query: OwnerQueryRequest): Promise<R<IPage<OwnerUserResponse>>> {
    return request('POST', '/customer/list', null, null, query, null, null);
  }

  // 查看客户配置详情
  public static quoteConfigDetailUsingGET(cusId: number, id: number): Promise<R<CustomerQuoteConfigDTO>> {
    return request('GET', '/customer/quoteConfigDetail', null, { cusId, id }, null, null, null);
  }

  // 客户报价配置分页查询
  public static quoteConfigPageUsingGET(
    carType?: number,
    cityCode?: string,
    countryCode?: string,
    countryName?: string,
    distance?: number,
    isAsc?: boolean,
    ownerId?: number,
    pageNo?: number,
    pageSize?: number,
    quoteType?: number,
    searchText?: string,
    sortBy?: string,
  ): Promise<R<IPage<QuoteConfigDTO>>> {
    return request(
      'GET',
      '/customer/quoteConfigPage',
      null,
      {
        carType,
        cityCode,
        countryCode,
        countryName,
        distance,
        isAsc,
        ownerId,
        pageNo,
        pageSize,
        quoteType,
        searchText,
        sortBy,
      },
      null,
      null,
      null,
    );
  }

  // 修改客户登陆账号密码
  public static resetPwdUsingPOST(userRequest: OwnerUserPwdRequest): Promise<R<string>> {
    return request('POST', '/customer/resetPwd', null, null, userRequest, null, null);
  }

  // 简单列表查询-查询条件使用
  public static listCustomerUsingPOST(query: OwnerQueryRequest): Promise<R<IPage<CustomerResponse>>> {
    return request('POST', '/customer/simpleList', null, null, query, null, null);
  }

  // 新增编辑报价配置
  public static updateCusQuoteConfigUsingPOST(quoteConfigDTO: CustomerQuoteConfigDTO): Promise<R<boolean>> {
    return request('POST', '/customer/updateQuoteConfig', null, null, quoteConfigDTO, null, null);
  }

  // 客户禁用启用
  public static updateCustomerVisibleUsingPUT(statusVo: SysUserStatusVo): Promise<R<string>> {
    return request('PUT', '/customer/updateStatus', null, null, statusVo, null, null);
  }
}
